export const HeadWrapper =
  'text-14 text-grayRegular border-machine2-75 flex w-full flex-row justify-between border-b py-2'

export const StatusesWrapper =
  'flex w-full flex-col py-4 sm:flex-row sm:py-6 md:pt-8'

export const StatusesLeftColumnWrapper =
  'flex w-full shrink-0 flex-col justify-between sm:w-1/2'

export const StatusesRightColumnWrapper =
  'flex w-full shrink-0 flex-col justify-start pt-4 sm:w-1/2 sm:items-end sm:pt-0'

export const OrderStatus = 'font-bold mb-2 md:mb-4'

export const OrderDeliveryDate = 'font-bold mb-2 md:mb-4'

export const OrderInvoiceItemWrapper =
  'group flex items-start pb-1 last-of-type:pb-0'

export const OrderInvoiceItemIcon = 'text-mediumGray mr-1'

export const OrderInvoiceItemName =
  'group-hover:font-Roboto group-hover:underline'
